import { getBaseUrl, getH5Platform, getQueryString } from '@/utils/environment';
import store from '@/vuex';
import versions from '@/config/config-version';
import sentryUtil from '@/sub-tree/common/src/sentry/util';
import { queryAllDB, clearTable, insertDB, generateRandomUUID } from 'utils/indexDB/util';
import { fetch } from '@/utils/fetch';
import Vue from 'vue';

const isSupportIndexedDB = !!(window.indexedDB || window.webkitIndexedDB || window.mozIndexedDB || window.msIndexedDB);
const clientMap = {
  wx: 'WECHAT', //企业微信
  wxmp: 'WECHAT_SERVICE', //微信服务号
  dd: 'DINGTALK', //钉钉
  operation: 'DINGTALK', //在运营系统扫码进入钉钉
  cd: 'APP', //汇联易App
  webapp: 'WEB_APP', //汇联易在线H5
  lark: 'FEI_SHU', //飞书
  welink: 'WELINK', //welink
};
const userAgent = window.navigator.userAgent;
const hostName = window.location.host;

let client, superTraceId;

function basicTemplate(logType = 'api') {
  if (!client) {
    client = clientMap[getH5Platform()] || 'APP';
  }
  if (!superTraceId) {
    superTraceId = sessionStorage.getItem('hly.superTraceId');
  }
  return {
    UUID: generateRandomUUID(),
    logType: logType,
    superTraceId: superTraceId,
    browserInfo: userAgent,
    client: client,
    appVersion: versions.appVersion,
    vip: 0,
    hostName: hostName,
    errMsg: '',
    statusCode: '',
    url: '',
    cost: '',
    spanId: '',
    traceId: '',
    requestId: '',
    seq: moment().valueOf(),
    atlSuperFrontTraceLogDetailVO: { param: '', response: '', stackTrace: '' },
  };
}

function cutArray(array, subLength) {
  let index = 0;
  const newArr = [];
  while (index < array.length) {
    newArr.push(array.slice(index, (index += subLength)));
  }
  return newArr;
}
/*
 当长度超过100时会上报
 */
let checking = false;
export const checkLength = async () => {
  checking = true;
  const logTable = await queryAllDB({
    tableName: 'logTable',
    localStorageName: 'alternative-localStorage-logTable',
  });
  const sendList = cutArray(logTable, 1000);
  if ((sendList[0] || []).length > 100) {
    Promise.all(
      sendList.map((itemList) =>
        fetch({
          url: '/expense/frontsupertrace/upsertBatch?roleType=TENANT',
          data: itemList,
          method: 'POST',
        })
      )
    ).finally(() => {
      clearTable({ tableName: 'logTable', localStorageName: 'alternative-localStorage-logTable' }).then();
      checking = false;
    });
  } else {
    checking = false;
  }
};

var _helios_track_event = (function (exports) {
  var _event_stack = [];
  const { iterationVersion } = versions;
  function _getBrowserInfo() {
    var userAgent = window.navigator.userAgent; //取得浏览器的userAgent字符串
    var version = function (reg) {
      return userAgent.match(reg) ? userAgent.match(reg)[1] : '0';
    };
    var re = {
      name: userAgent,
      version: '0',
    };
    if (userAgent.indexOf('Opera') > -1) {
      ////判断是否Opera浏览器
      re.name = 'Opera';
      re.version = version(/opera.([\d.]+)/i);
      return re;
    }
    if (userAgent.indexOf('Firefox') > -1) {
      //判断是否Firefox浏览器
      re.name = 'Firefox';
      re.version = version(/firefox.([\d.]+)/i);
      return re;
    }
    if (userAgent.indexOf('Chrome') > -1) {
      //判断是否Chrome浏览器
      re.name = 'Chrome';
      re.version = version(/chrome.([\d.]+)/i);
      return re;
    }
    if (userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 && userAgent.indexOf('Opera') === -1) {
      re.name = 'IE';
      re.version = version(/msie ([\d.]+)/i);
      return re;
    }
    if (userAgent.indexOf('Edge') > -1) {
      re.name = 'Edge';
      re.version = version(/edge.([\d.]+)/i);
      return re;
    }
    if (userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1) {
      re.name = 'IE11';
      re.version = '11';
    }
    if (userAgent.indexOf('Version') > -1) {
      //判断是否Safari浏览器
      re.name = 'Safari';
      re.version = version(/version\/([\d.]+).*safari/i);
      return re;
    }
    return re;
  }
  async function push(event) {
    try {
      if (!Array.isArray(event)) return;
      event.forEach((item) => {
        item.UUID = generateRandomUUID();
        return item;
      });
      if (isSupportIndexedDB)
        await insertDB({
          tableName: 'eventStack',
          data: event,
          localStorageName: 'alternative-localStorage-eventStack',
        });
      else _event_stack = _event_stack.concat(event);
    } catch (e) {}
  }
  async function clear() {
    if (isSupportIndexedDB)
      await clearTable({ tableName: 'eventStack', localStorageName: 'alternative-localStorage-eventStack' });
    else _event_stack = [];
  }
  async function report() {
    try {
      if (!sentryUtil.shouldReportData(store.getters.getCompanyConfigurations)) return;
      const eventList = isSupportIndexedDB
        ? await queryAllDB({
            tableName: 'eventStack',
            localStorageName: 'alternative-localStorage-eventStack',
          })
        : _event_stack;
      if (!eventList || (Array.isArray(eventList) && eventList.length === 0)) return;
      var token = '';
      if (store.getters.getUserToken) {
        token = store.getters.getUserToken.access_token;
      }
      if (!token) return;
      var body = {
        browserInfo: _getBrowserInfo().name + ' ' + _getBrowserInfo().version,
        client: clientMap[getH5Platform()] || 'APP',
        appSystemCode: '',
        appVersionCode: iterationVersion,
        deviceBrand: '',
        deviceVersion: '',
        vip: 0,
        details: eventList,
      };
      let corpId = getQueryString('corpId') || sessionStorage.getItem('corpId');
      if (navigator.sendBeacon) {
        const blob = new Blob([JSON.stringify(body)], { type: 'text/plain' });
        const result = navigator.sendBeacon(
          `${getBaseUrl()}/api/operation/user/event/data?access_token=${token}&corpId=${corpId}`,
          blob
        );
        result && clear();
      } else {
        var client = new XMLHttpRequest();
        client.open('POST', getBaseUrl() + '/api/operation/user/event/data', false);
        client.setRequestHeader('Content-Type', 'application/json');
        client.setRequestHeader('Authorization', 'Bearer ' + token);
        corpId && client.setRequestHeader('corpid', corpId);
        client.onreadystatechange = function () {
          if (client.readyState === 4 && client.status === 200) {
            if (client.responseText && JSON.parse(client.responseText).result === '0000') clear();
          }
        };
        client.send(JSON.stringify(body));
      }
    } catch (e) {}
  }
  async function recordRouteChange(url = '') {
    insertDB({
      tableName: 'logTable',
      localStorageName: 'alternative-localStorage-logTable',
      data: [
        {
          ...basicTemplate('route'),
          url: url,
        },
      ],
    }).then(() => {
      !checking && checkLength();
    });
  }
  async function recordJsError(error, errorInfo) {
    insertDB({
      tableName: 'logTable',
      localStorageName: 'alternative-localStorage-logTable',
      data: [
        {
          ...basicTemplate('jsError'),
          errMsg: (error && error.message) || (error && error.description),
          atlSuperFrontTraceLogDetailVO: {
            param: '',
            response: JSON.stringify({
              error: { message: error.message, name: error.name, stack: error.stack },
              errorInfo,
            }),
            stackTrace: (error && error.stack) || '',
          },
        },
      ],
    }).then(() => {
      !checking && checkLength();
    });
  }
  async function recordHttpFetch({ data, duration }) {
    insertDB({
      tableName: 'logTable',
      localStorageName: 'alternative-localStorage-logTable',
      data: [
        {
          ...basicTemplate('api'),
          url: data.config && data.config.url,
          statusCode: data.status,
          cost: duration,
          errMsg: `${data.status}`.startsWith('20')
            ? ''
            : Vue.prototype.COMMON.getErrorMessage({ response: data }) || '',
          spanId: data.headers && data.headers.spanid,
          traceId: data.headers && data.headers.traceid,
          requestId: data.config && data.config.headers && data.config.headers.requestID,
          atlSuperFrontTraceLogDetailVO: {
            param: JSON.stringify({
              headers: data.config && data.config.headers && { ...data.config.headers, Authorization: undefined },
              method: data.config && data.config.method,
              params: data.config && data.config.params,
              data: data.config && data.config.data,
              url: data.config && data.config.url,
            }),
            response: JSON.stringify({ responseHeaders: data && data.headers, responseData: data && data.data }),
            stackTrace: '',
          },
        },
      ],
    }).then(() => {
      !checking && checkLength();
    });
  }
  async function reportLogTable() {
    const logTable = await queryAllDB({
      tableName: 'logTable',
      localStorageName: 'alternative-localStorage-logTable',
    });
    const sendList = cutArray(logTable, 1000);
    Promise.all(
      sendList.map((itemList) =>
        fetch({
          url: '/expense/frontsupertrace/upsertBatch',
          data: itemList,
          method: 'POST',
        })
      )
    ).finally(() => {
      superTraceId = undefined;
      sessionStorage.removeItem('hly.superTraceId');
      clearTable({ tableName: 'logTable', localStorageName: 'alternative-localStorage-logTable' }).then();
    });
  }
  async function reportLogTableWithVisibility() {
    const logTable = await queryAllDB({
      tableName: 'logTable',
      localStorageName: 'alternative-localStorage-logTable',
    });
    let corpId = getQueryString('corpId') || sessionStorage.getItem('corpId');
    var token = '';
    if (store.getters.getUserToken) {
      token = store.getters.getUserToken.access_token;
    }
    if (!token) return;
    const sendList = cutArray(logTable, 1000);
    sendList.map((itemList) => {
      if (navigator.sendBeacon) {
        let result = false;
        let blob = new Blob([JSON.stringify(itemList)], { type: 'text/plain' });
        result = navigator.sendBeacon(
          `/expense/frontsupertrace/front/trace/uploadBatch?access_token=${token}&corpId=${corpId}`,
          blob
        );
        if (result) {
          superTraceId = undefined;
          sessionStorage.removeItem('hly.superTraceId');
          clearTable({ tableName: 'logTable', localStorageName: 'alternative-localStorage-logTable' }).then();
        }
      } else {
        const XHR = new XMLHttpRequest();
        XHR.open('POST', '/expense/frontsupertrace/front/trace/uploadBatch', false);
        XHR.setRequestHeader('Content-Type', 'application/json');
        XHR.setRequestHeader('Authorization', 'Bearer ' + token);
        corpId && XHR.setRequestHeader('corpid', corpId);
        XHR.onreadystatechange = function () {
          if (XHR.readyState === 4 && XHR.status === 200) {
            if (XHR.responseText && JSON.parse(XHR.responseText).result === '0000') {
              superTraceId = undefined;
              sessionStorage.removeItem('hly.superTraceId');
              clearTable({ tableName: 'logTable', localStorageName: 'alternative-localStorage-logTable' }).then();
            }
          }
        };
        XHR.send(JSON.stringify(itemList));
      }
    });
  }
  exports.recordRouteChange = recordRouteChange;
  exports.recordJsError = recordJsError;
  exports.recordHttpFetch = recordHttpFetch;
  exports.reportLogTable = reportLogTable;
  exports.reportLogTableWithVisibility = reportLogTableWithVisibility;
  exports.push = push;
  exports.report = report;
  window._helios_track_event = exports;
  return exports;
})({});
window._helios_track_event = _helios_track_event;

let hidden, visibilityChange;
if (typeof document.hidden !== 'undefined') {
  hidden = 'hidden';
  visibilityChange = 'visibilitychange';
} else if (typeof document.mozHidden !== 'undefined') {
  hidden = 'mozHidden';
  visibilityChange = 'mozvisibilitychange';
} else if (typeof document.msHidden !== 'undefined') {
  hidden = 'msHidden';
  visibilityChange = 'msvisibilitychange';
} else if (typeof document.webkitHidden !== 'undefined') {
  hidden = 'webkitHidden';
  visibilityChange = 'webkitvisibilitychange';
}
document.addEventListener(visibilityChange, function () {
  if (document[hidden]) {
    _helios_track_event.report();
    window?._helios_performance_monitoring?.reportPerformanceData();
    if (superTraceId) {
      window._helios_track_event.reportLogTableWithVisibility();
    }
  }
});
if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
  window.addEventListener('pagehide', function () {
    _helios_track_event.report();
    window?._helios_performance_monitoring?.reportPerformanceData();
    if (superTraceId) {
      window._helios_track_event.reportLogTableWithVisibility();
    }
  });
}
